module.exports = __webpack_public_path__ + "media/images/athletes/3567-3470560871bcaa2c0354ad814ccd9069.png";